/*
view_ukFirstTimeDepositLink
*/

import actions from '../../common/lib/utils/actions.js';
import core from './../../common/lib/core.js';
import viewTextkeys from './../../commonview/lib/view-textkeys.js';
import viewInputPopupCreator from './../../commonview/lib/view-inputpopup.js';

const create = core.create; // creates basic elements not inserted into the dom
const classnameShow = 'u-show';
const classnameHide = 'u-hide';
let textkeysObj;
let viewInputPopup;

function createWrap(eventFilter) {
	const cName = `${eventFilter} set-limit-wrap ukfirsttimedepositlink`;
	return create({
		type: 'div',
		// class: 'set-limit-wrap'
		class: cName
	});
}

function createLink(txt) {
	const elm = create({
		type: 'a',
		class: 'set-limit-link',
		name: 'set-limit-link'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	const eventFilterSelector = `.${eventFilterSeparatorClassname}`;

	function cb(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		viewInputPopup.show();
		onEventCb();
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	core.handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	core.addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	if (elm) {
		core.removeListener(elm, eventType, handler);
	}
}

function show(elm) {
	if (elm) {
		core.removeClass(elm, classnameHide);
		core.addClass(elm, classnameShow);
	}
}

function hide(elm) {
	core.removeClass(elm, classnameShow);
	core.addClass(elm, classnameHide);
}

export default {
	create() {
		let elements = {};
		const classNameEventFilter = 'js-eventfilter-ukfirsttimedepositlink';
		const mainEventType = 'click';
		textkeysObj = viewTextkeys.depositflow();
		elements.wrap = (elements.wrap || createWrap(classNameEventFilter));
		elements.link = (elements.link || createLink(textkeysObj['set-limit-link']));
		elements.wrap.appendChild(elements.link);
		const callbackOnMainEvent = function temp() {};
		const handler = addListeners(elements.wrap, callbackOnMainEvent, classNameEventFilter, mainEventType);

		function confirmCb(value) {
			actions.viewUkFirstTimeDepositLink(value);
			// viewInputPopup = viewInputPopup.close();
			viewInputPopup.hide();
		}

		function rejectCb() {
			viewInputPopup.hide();
		}
		viewInputPopup = (viewInputPopup || viewInputPopupCreator.create({
			confirmCb,
			rejectCb
		}));
		return {
			wrap: elements.wrap,
			show() {
				show(elements.wrap);
			},
			hide() {
				hide(elements.wrap);
			},
			update() {},
			close() {
				removeListeners(elements.wrap, handler, mainEventType);
				elements = core.deleteElementsInObjectExcept(elements, [], 'view_ukFirstTimeDepositLink:81');
				if (viewInputPopup && viewInputPopup.close) {
					viewInputPopup.close();
					viewInputPopup = null;
				}
			}
		};
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/view-ukFirstTimeDepositLink.js